import { useState } from "react";
import { motion } from "framer-motion";
import { Play } from "lucide-react";

export default function HeroSection() {
  const [showReel, setShowReel] = useState(false);

  return (
    <>
      <section className="relative pt-20 bg-[#F8F6F3]" data-testid="hero-section">
        <div className="max-w-7xl mx-auto px-6 md:px-12 pt-16 md:pt-24 pb-12">
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="text-xs uppercase tracking-[0.25em] font-semibold text-[#1C1C1C]/40 mb-8"
          >
            § 01 / Creative Studio
          </motion.p>

          <motion.h1
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.1 }}
            className="text-5xl sm:text-6xl md:text-8xl lg:text-[7rem] font-black tracking-tighter leading-[0.9] text-[#1C1C1C] max-w-6xl mb-10"
          >
            Motion, design & content that gets you{" "}
            <em className="not-italic text-[#FF5E3A]">noticed.</em>
          </motion.h1>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.3 }}
            className="flex flex-col sm:flex-row gap-4 mb-16"
          >
            <a href="/portfolio">
              <button className="bg-[#FF5E3A] text-white font-semibold text-sm px-8 py-4 rounded-full hover:bg-[#1C1C1C] transition-colors duration-300" data-testid="hero-cta-work">
                View My Work →
              </button>
            </a>
            <a href="/contact">
              <button className="border-2 border-[#1C1C1C]/15 text-[#1C1C1C] font-semibold text-sm px-8 py-4 rounded-full hover:border-[#FF5E3A] hover:text-[#FF5E3A] transition-colors duration-300" data-testid="hero-cta-project">
                Start a Project
              </button>
            </a>
          </motion.div>
        </div>

        {/* Showreel Video */}
        <motion.div
          initial={{ opacity: 0, y: 60 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.4 }}
          className="max-w-7xl mx-auto px-6 md:px-12 pb-24"
        >
          <div
            className="relative aspect-video bg-[#1C1C1C] rounded-2xl overflow-hidden cursor-pointer group"
            onClick={() => setShowReel(true)}
            data-testid="showreel-area"
          >
            <video
              src="https://customer-assets.emergentagent.com/job_90d7605f-c48c-4b5a-96e9-049874292b41/artifacts/3ifn5bzm_My-Showreel-26.mp4"
              autoPlay
              muted
              loop
              playsInline
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-black/20 group-hover:bg-black/40 transition-colors duration-300" />
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="w-20 h-20 md:w-24 md:h-24 flex items-center justify-center rounded-full bg-[#FF5E3A] group-hover:scale-110 transition-transform duration-300">
                <Play size={32} fill="white" stroke="white" className="ml-1" />
              </div>
            </div>
            <div className="absolute bottom-6 left-6 md:bottom-8 md:left-8">
              <span className="text-xs uppercase tracking-[0.25em] font-semibold text-white/70">
                Showreel 2026
              </span>
            </div>
          </div>
        </motion.div>
      </section>

      {showReel && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/90"
          onClick={() => setShowReel(false)}
          data-testid="showreel-modal"
        >
          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            className="w-full max-w-6xl mx-4"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="aspect-video bg-black rounded-2xl overflow-hidden">
              <video
                src="https://customer-assets.emergentagent.com/job_90d7605f-c48c-4b5a-96e9-049874292b41/artifacts/3ifn5bzm_My-Showreel-26.mp4"
                controls
                autoPlay
                playsInline
                className="w-full h-full object-contain"
              />
            </div>
            <button
              className="absolute top-4 right-4 text-white/70 hover:text-white text-sm font-semibold bg-black/50 px-4 py-2 rounded-full"
              onClick={() => setShowReel(false)}
              data-testid="close-showreel-btn"
            >
              Close
            </button>
          </motion.div>
        </div>
      )}
    </>
  );
}
